import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

export default function BrandHpOmen() {
  return (
    <div className="navbar-brand NavBar__brandContainer NavBar__brandContainer--hpomen">
      <Link to="/" className="NavBar__brandLogo">
        <img src="https://cdn.fanatical.com/production/brand/fanatical-logo-white.svg" alt="Fanatical" />
      </Link>
      <div className="NavBar__brandAssociation">
        <FormattedMessage id="brand-hpomen.curated-for" defaultMessage="Curated for" />
        <img src="https://cdn.fanatical.com/production/brand/co-brands/omen-gaming-hub-logo-color.svg" alt="Omen Gaming Hub" className="NavBar__brandAssociation__image" />
      </div>
    </div>
  );
}
